export function getOnboardLink(userId: string, workspaceId?: string) {
  return `/onboard/${[userId, workspaceId].filter(Boolean).join('/')}`
}
